"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _BuyButton = require("./BuyButton");
Object.keys(_BuyButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BuyButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BuyButton[key];
    }
  });
});
